import React from 'react'
import FooterImg from '../../assets/img/logo.png'
import googleStore from '../../assets/img/Google_Store.png'
import appStore from '../../assets/img/Store.png'
import { Link } from 'react-router-dom'

function Footer() {
  const currentYear = new Date().getFullYear()
  return (
    <section className='footer'>
        <div className='container'>
          <div className='row justify-content-between mb-5'>
            <div className='col-12 col-lg-4 mb-5 mb-lg-0'>
              <div className='footer__logo mb-4'>
                <img src={FooterImg} className='img-fluid' width={160} alt='footer logo' />
              </div>
              <p className='footer__logo__text mb-4 text-white-50'>
                Borderless Money movement for Africans & African Businesses
              </p>
              <div className='d-flex gap-3'>
                <Link to=''><img src={googleStore} alt='Google Play Store' className='img-fluid store-btn' width={135} /></Link>
                <Link to=''><img src={appStore} alt='Apple App Store' className='img-fluid store-btn' width={135} /></Link>
              </div>
            </div>
            
            <div className='col-6 col-lg-2 mb-4 mb-lg-0'>
              <div className='footer__links'>
                <h3 className='footer__links__title'>Company</h3>
                <ul className='footer__links__list'>
                  <li><Link to='/about'>About Us</Link></li>
                  <li><Link to='/contact'>Contact us</Link></li>
                  <li><Link to='/leaderboard'>Leaderboard</Link></li>
                  <li><Link to='/about'>How it works</Link></li>
                  <li><Link to='/'>Partners</Link></li>
                </ul>
              </div>
            </div>

            <div className='col-6 col-lg-2 mb-4 mb-lg-0'>
              <div className='footer__links'>
                <h3 className='footer__links__title'>Product</h3>
                <ul className='footer__links__list'>
                  <li><Link to='/'>Virtual Accounts</Link></li>
                  <li><Link to='/'>Send Money</Link></li>
                  <li><Link to='/'>Virtual Cards</Link></li>
                  <li><Link to='/'>Payment Link</Link></li>
                  <li><Link to='/'>Exchange Currency</Link></li>
                </ul>
              </div>
            </div>

            <div className='col-12 col-lg-2'>
              <div className='footer__links mb-4'>
                <h3 className='footer__links__title'>Resources</h3>
                <ul className='footer__links__list'>
                  <li><Link to='/'>Help Centre</Link></li>
                  <li><Link to='/'>FAQs</Link></li>
                  <li><Link to='https://blog.cardplot.com/'>News & Blog</Link></li>
                  <li><Link to='/career'>Careers</Link></li>
                  <li><Link to='https://linktr.ee/usecardplot'>Linktree</Link></li>
                </ul>
              </div>
            </div>
          </div>  

          <div className="row align-items-center mb-4">
            <div className='col-lg-6 mb-3 mb-lg-0'>
              <div className="d-flex flex-column gap-2">
                <div className="d-flex align-items-start gap-2 footer__address">
                  <i className="fas fa-map-marker-alt text-primary mt-1"></i>
                  <span>10 Toyin Street, Ikeja City, Lagos State, Nigeria</span>
                </div>
                <div className="d-flex align-items-start gap-2 footer__address">
                  <i className="fas fa-map-marker-alt text-primary mt-1"></i>
                  <span>71-75 Shelton Street, Covent Garden, London, WC2H 9JQ</span>
                </div>
              </div>
            </div>
            <div className='col-lg-6 d-flex justify-content-lg-end'>
              <div className='footer-social d-flex gap-2 align-items-center flex-wrap'>
                  <span className="text-white-50 me-2 fw-semibold d-none d-sm-block">Connect with us:</span>
                  <Link to='https://linkedin.com/company/cardplot' title='LinkedIn'>
                    <i className="fab fa-linkedin"></i>
                  </Link>
                  <Link to='https://x.com/Usecardplot' title='X (Twitter)'>
                    <i className="fab fa-twitter"></i>  
                  </Link>
                  <Link to='https://www.instagram.com/usecardplot/' title='Instagram'>
                    <i className="fab fa-instagram"></i>
                  </Link>
                  <Link to='https://www.facebook.com/usecardplot' title='Facebook'>
                    <i className="fab fa-facebook"></i>
                  </Link>
                  <Link to='https://www.tiktok.com/@usecardplot' title='TikTok'>
                    <i className="fab fa-tiktok"></i>
                  </Link>
                  <Link to='https://www.youtube.com/@usecardplot' title='YouTube'>
                    <i className="fab fa-youtube"></i>
                  </Link>
                  <Link to='https://whatsapp.com/channel/0029Vb79EKfD38COSUr8Qi42' title='WhatsApp'>
                    <i className="fab fa-whatsapp"></i>
                  </Link>
                  <Link to='https://t.me/cardplot' title='Telegram'>
                    <i className="fab fa-telegram-plane"></i>
                  </Link>
              </div>
            </div>
          </div> 

          <div className="footer__border__bottom__line mb-4"></div>
          
          <div className="row mb-4">
            <div className="col-lg-12">
              <div className="footer-disclaimer">
                <p className="text-white-50 small mb-0" style={{ lineHeight: '1.8' }}>
                  ©{currentYear} Cardplot Technologies Limited is a financial technology company that facilitates
                  cross-border transactions and is not a bank. Banking services are provided by licensed 
                  banks and financial institutions partners in their respective jurisdictions.
                  Unauthorized reproduction or redistribution of copyrighted materials on this website or
                  on Cardplot’s digital media pages is strictly prohibited. 
                  By clicking on some of the links above, you may leave Cardplot’s website and 
                  be directed to a third-party website. 
                  The privacy practices of those third parties may differ from those of Cardplot. 
                  We recommend that you review the privacy statements of those third-party websites, 
                  as Cardplot is not responsible for their privacy or security practices. 
                  Additional disclosures can be found in the Resources section of our website.
                </p>
              </div>
            </div>
          </div>
            
          <div className="row align-items-center">
            <div className="col-lg-6 mb-3 mb-lg-0">
              <div className="copyright__text">
                <p className="mb-0 text-white-50">Copyright ©{currentYear}, Cardplot Technologies Limited. All rights reserved.</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="footer-privacy d-flex justify-content-lg-end gap-4">
                <Link to='/legal'>Terms of use</Link>
                <Link to='/privacy-policy'>Privacy Policy</Link>
                <Link to='/aml'>AML & CTF</Link>
              </div>
            </div>
          </div>    
        </div>
      </section>
  )
}

export default Footer